import { useQuery, useMutation, useQueryClient } from 'react-query';
import { UserHttpService } from 'core/services/user';

const useEducations = (cvId = null) => {
    const queryClient = useQueryClient();

    // Query for fetching educations
    const { data, isLoading, error } = useQuery(['educations', cvId], async () => {
        const response = await UserHttpService.listEducations(cvId);

        return response.results || [];
    });

    // Mutation for adding an education
    const addEducationMutation = useMutation(
        async (newEducation) => {
            return await UserHttpService.createEducation(newEducation);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch educations query
                queryClient.invalidateQueries(['educations', cvId]);
            }
        }
    );

    // Mutation for updating an education
    const updateEducationMutation = useMutation(
        async (updatedEducation) => {
            return await UserHttpService.updateEducation(updatedEducation.id, updatedEducation);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch educations query
                queryClient.invalidateQueries(['educations', cvId]);
            }
        }
    );

    // Mutation for deleting an education
    const deleteEducationMutation = useMutation(
        async (id) => {
            return await UserHttpService.deleteEducation(id);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch educations query
                queryClient.invalidateQueries(['educations', cvId]);
            }
        }
    );

    return {
        educations: data || [],
        isLoading,
        error: error ? error.message : null,
        addEducation: addEducationMutation.mutateAsync,
        updateEducation: updateEducationMutation.mutateAsync,
        deleteEducation: deleteEducationMutation.mutateAsync
    };
};

export default useEducations; 